import React from 'react';
import { Typography } from '@mui/material';
import UAParser from 'ua-parser-js';
import { PreviewTrigger } from './PreviewModal';

export function useTraceUpdate(props) {
  const prev = React.useRef(props);
  React.useEffect(() => {
    const changedProps = Object.entries(props).reduce((ps, [k, v]) => {
      if (prev.current[k] !== v) {
        ps[k] = [prev.current[k], v];
      }
      return ps;
    }, {});
    if (Object.keys(changedProps).length > 0) {
      console.log('Changed props:', changedProps);
    }
    prev.current = props;
  });
}

export function parseText (title = '') {
  if (typeof title !== 'string') return '';
  return title.replace(/\/\*.*\*\//g, '');
}

export function FormText ({ data, ...props }) {
  if (data && data.length > 0) {
    return <PreviewTrigger>
      {(handler) => <Typography {...props} dangerouslySetInnerHTML={{ __html: data }} ref={handler} />}
    </PreviewTrigger>
  }
  return null;
}

const SYSTEM_LOGS_SUPPORT = {
  'android': 3491,
  'ios': 3017,
};

export function isSystemLogsSupport (platform, version) {
  const support = SYSTEM_LOGS_SUPPORT[platform];
  if (support) {
    return version >= support;
  }
  return false;
}

export function getOsVersion (userAgent) {
  const parser = new UAParser(userAgent);
  const browser = parser.getBrowser();
  return [browser.name, browser.version].filter(Boolean).join(' ');
}

export function getModel (userAgent) {
  const parser = new UAParser(userAgent);
  const os = parser.getOS();
  return [os.name, os.version].filter(Boolean).join(' ');
}

export function getCookie (name) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return (parts.pop() || '').split(';').shift();
}

export function openUrl(url, options) {
  if (typeof window.AlfredJsBridge?.openUrl === 'function') {
    window.AlfredJsBridge.openUrl(url, JSON.stringify(options));
  } else {
    window.open(url);
  }
}
